import { Badge } from '@radix-ui/themes'
import { ComponentProps } from 'react'
import { PamPlayerVerificationStatus } from '@Generated/back-office-client/src'

type BadgeColor = ComponentProps<typeof Badge>['color']

export type StatusDisplay = {
  label: string
  tooltip: string
  color: BadgeColor
}

// Keyed by the 7 real status values only. The sentinel value '11184809'
// (openapi-generator unknown default) is intentionally omitted so it falls
// through getStatusDisplay's gray fallback and is excluded from the dropdown.
export const STATUS_DISPLAY: Record<string, StatusDisplay> = {
  [PamPlayerVerificationStatus.not_started]: {
    label: 'Not started',
    tooltip: "Player hasn't submitted verification yet.",
    color: 'gray',
  },
  [PamPlayerVerificationStatus.submitted]: {
    label: 'Submitted',
    tooltip: 'Verification in progress with the identity vendor.',
    color: 'blue',
  },
  [PamPlayerVerificationStatus.approved]: {
    label: 'Approved',
    tooltip: 'Identity verified; account active.',
    color: 'green',
  },
  [PamPlayerVerificationStatus.rejected]: {
    label: 'Rejected — retries remaining',
    tooltip: 'Vendor declined this attempt; the player can try again.',
    color: 'orange',
  },
  [PamPlayerVerificationStatus.locked]: {
    label: 'Locked — attempts exhausted',
    tooltip: 'Player used all verification attempts; needs a staff unlock to retry.',
    color: 'red',
  },
  [PamPlayerVerificationStatus.denied]: {
    label: 'Denied — staff decision',
    tooltip: 'A staff member manually denied this player; re-submission is blocked.',
    color: 'ruby',
  },
  [PamPlayerVerificationStatus.duplicate_review]: {
    label: 'Duplicate — needs review',
    tooltip: 'DOB + SSN4 match an existing account; review, then deny or unlock.',
    color: 'amber',
  },
  [PamPlayerVerificationStatus.manually_approved]: {
    label: 'Manually Approved',
    tooltip: 'Back-office staff manually cleared this player after review.',
    color: 'green',
  },
}

export const getStatusDisplay = (status: string): StatusDisplay => {
  const known = STATUS_DISPLAY[status]
  if (!known) {
    return { label: status, tooltip: 'Unrecognized status from the server.', color: 'gray' }
  }
  return known
}
